/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Detail_Headline_CnaInputs */

const en_subscription_detail_headline_cna = /** @type {(inputs: Subscription_Detail_Headline_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Benefits Details`)
};

const ar_subscription_detail_headline_cna = /** @type {(inputs: Subscription_Detail_Headline_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Benefits Details`)
};

const de_subscription_detail_headline_cna = /** @type {(inputs: Subscription_Detail_Headline_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Benefits Details`)
};

const es_subscription_detail_headline_cna = /** @type {(inputs: Subscription_Detail_Headline_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Benefits Details`)
};

const fr_subscription_detail_headline_cna = /** @type {(inputs: Subscription_Detail_Headline_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Benefits Details`)
};

const it_subscription_detail_headline_cna = /** @type {(inputs: Subscription_Detail_Headline_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Benefits Details`)
};

const ja_subscription_detail_headline_cna = /** @type {(inputs: Subscription_Detail_Headline_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Benefits Details`)
};

const ko_subscription_detail_headline_cna = /** @type {(inputs: Subscription_Detail_Headline_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Benefits Details`)
};

const pt_br_subscription_detail_headline_cna = /** @type {(inputs: Subscription_Detail_Headline_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Benefits Details`)
};

const ru_subscription_detail_headline_cna = /** @type {(inputs: Subscription_Detail_Headline_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Benefits Details`)
};

const th_subscription_detail_headline_cna = /** @type {(inputs: Subscription_Detail_Headline_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Benefits Details`)
};

const tr_subscription_detail_headline_cna = /** @type {(inputs: Subscription_Detail_Headline_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Membership Benefits Details`)
};

const zh_cn_subscription_detail_headline_cna = /** @type {(inputs: Subscription_Detail_Headline_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 会员权益说明`)
};

const zh_tw_subscription_detail_headline_cna = /** @type {(inputs: Subscription_Detail_Headline_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 会员权益说明`)
};

/**
* | output |
* | --- |
* | "Plus Membership Benefits Details" |
*
* @param {Subscription_Detail_Headline_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_detail_headline_cna = /** @type {((inputs?: Subscription_Detail_Headline_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Detail_Headline_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_detail_headline_cna(inputs)
	if (locale === "ar") return ar_subscription_detail_headline_cna(inputs)
	if (locale === "de") return de_subscription_detail_headline_cna(inputs)
	if (locale === "es") return es_subscription_detail_headline_cna(inputs)
	if (locale === "fr") return fr_subscription_detail_headline_cna(inputs)
	if (locale === "it") return it_subscription_detail_headline_cna(inputs)
	if (locale === "ja") return ja_subscription_detail_headline_cna(inputs)
	if (locale === "ko") return ko_subscription_detail_headline_cna(inputs)
	if (locale === "pt_br") return pt_br_subscription_detail_headline_cna(inputs)
	if (locale === "ru") return ru_subscription_detail_headline_cna(inputs)
	if (locale === "th") return th_subscription_detail_headline_cna(inputs)
	if (locale === "tr") return tr_subscription_detail_headline_cna(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_detail_headline_cna(inputs)
	return zh_tw_subscription_detail_headline_cna(inputs)
});